export default {
    gray: "gray",
    wrong: "wrong",
    success: "success",
    none: "none"
};
